angular.module('picmonic-common').directive('mobileAppLink', [
  'UserService',
  function (UserService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.attr('href', UserService.getMobileAppUrl(attrs.mobileAppLink, attrs.marketId));
      },
    };
  },
]);
